/* eslint-disable react/prop-types */
import { Switch, Route, Redirect } from 'react-router-dom'
import { get } from 'lodash'
import useSession from 'hooks/useSession'
import ErrorBoundary from 'controllers/ErrorBoundary'
import Spinner from 'components/Spinner'
import BookingHeader from 'apps/booking/components/Header'
import AccessTokenWrapper from 'components/AccessToken'

import OrgunitIndex from './pages/OrgunitIndex'
import LoginPage from './pages/Login'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Booking from './pages/Booking'
import Confirmation from './pages/Confirmation'
import WaitingList from './pages/WaitingList'
import FluRejection from './pages/FluRejection'
import ClinicalRejection from './pages/ClinicalRejection'
import Refusal from './pages/Refusal'
import LoginError from './pages/LoginError'
import EditBooking from './wizard/steps/EditBooking'
import BookingUnavailablePage from './pages/BookingUnavailable'
import BookingFailedBehalfOfPage from './pages/BookingFailedBehalfOf'

const errorHeader = <BookingHeader />

export function InnerApp() {
  const { isLoading, isSignedIn } = useSession()

  if (isLoading) {
    return <Spinner box={false} full />
  }

  return (
    <Switch>
      {/* // We made a mistake using custom slugs, and have to redirect so the muncipalities doesn't get broken links */}
      <Route
        exact
        path="/eidsvoll"
        render={(props) => <Redirect to={`/dgi-eidsvoll${props.location.search}`} />}
      />
      <Route
        exact
        path="/norge"
        render={(props) => <Redirect to={`/dgi-nes${props.location.search}`} />}
      />
      <Route
        exact
        path="/hurdal"
        render={(props) => <Redirect to={`/dgi-hurdal${props.location.search}`} />}
      />
      <Route
        exact
        path="/vagan"
        render={(props) => <Redirect to={`/vaagan${props.location.search}`} />}
      />
      {/* Temp fix for wrong url in SMS (see VAC-253) Can be removed in the future */}
      <Route
        exact
        path="/astafjord_-_salangen_vaksinasjon"
        render={(props) => <Redirect to={`/salangen${props.location.search}`} />}
      />

      <Route exact path="/" component={OrgunitIndex} />
      <Route exact path="/personvern" component={PrivacyPolicy} />
      <Route exact path="/:orgUnit/bekreftelse" component={Confirmation} />
      <Route exact path="/:orgUnit/venteliste" component={WaitingList} />
      <Route exact path="/:orgUnit/avslag-influensa" component={FluRejection} />
      <Route exact path="/:orgUnit/avslag-klinisk" component={ClinicalRejection} />
      <Route exact path="/:orgUnit/vil-ikke" component={Refusal} />
      <Route exact path="/:orgUnit/utilgjengelig" component={BookingUnavailablePage} />
      <Route exact path="/:orgUnit/bestilling-feilet" component={BookingFailedBehalfOfPage} />
      <Route
        exact
        path="/:orgUnit/endre-time/:bookingTypeId/:vaccinationId"
        component={EditBooking}
      />

      {!isSignedIn ? (
        <Switch>
          <Route exact path="/loggedin">
            <Redirect to={'/'} />
          </Route>
          <Route
            exact
            path="/:orgUnit"
            render={({
              match: {
                params: { orgUnit },
              },
            }) => <LoginPage orgUnit={orgUnit} redirectUrl={'/loggedin'} />}
          />

          <Route
            path="/:orgUnit"
            render={({
              match: {
                params: { orgUnit },
              },
            }) => <Redirect to={`/${orgUnit}`} />}
          />
        </Switch>
      ) : (
        <Route
          render={({ location }) => {
            const abortScroll = get(location, 'state.noScroll', false)
            document.body.classList.remove('block-scrolling')

            if (!abortScroll) {
              window.scrollTo(0, 0)
            }

            return (
              <Switch>
                <Route path="/feil" component={LoginError} />

                <Route path="/:orgUnit/:bookingType" component={Booking} />

                <Route
                  exact
                  path="/:orgUnit"
                  render={({
                    match: {
                      params: { orgUnit },
                    },
                  }) => <LoginPage orgUnit={orgUnit} />}
                />

                <Redirect to="/" />
              </Switch>
            )
          }}
        />
      )}
    </Switch>
  )
}

export default function App() {
  return (
    <ErrorBoundary application="booking" header={errorHeader}>
      <AccessTokenWrapper authContext="booking">
        <InnerApp />
      </AccessTokenWrapper>
    </ErrorBoundary>
  )
}
